import React, { useEffect, useMemo, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { subscribeToToasts } from '../../toast';

export default function ToastHost() {
  const [toastState, setToastState] = useState({
    open: false,
    key: 0,
    message: '',
    severity: 'info',
    autoHideDuration: 4000,
  });

  useEffect(() => {
    return subscribeToToasts((payload) => {
      setToastState({
        open: true,
        key: Date.now(),
        message: payload.message,
        severity: payload.severity,
        autoHideDuration: payload.autoHideDuration,
      });
    });
  }, []);

  const handleClose = (_event, reason) => {
    if (reason === 'clickaway') return;
    setToastState((current) => ({ ...current, open: false }));
  };

  const anchorOrigin = useMemo(() => ({ vertical: 'top', horizontal: 'right' }), []);

  return (
    <Snackbar
      key={toastState.key}
      open={toastState.open}
      autoHideDuration={toastState.autoHideDuration}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      sx={{ zIndex: (theme) => theme.zIndex.modal + 2 }}
    >
      <Alert
        onClose={handleClose}
        severity={toastState.severity}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {toastState.message}
      </Alert>
    </Snackbar>
  );
}
